/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
// import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import bgFooter from "assets/images/footer-bg.png";
import logoImage from "assets/images/logo-snlc.png";

const SocialIcon = styled("div")({
  color: "rgba(255, 255, 255, 0.6)",
  backgroundColor: "transparent",
  padding: 1,
  textTransform: "uppercase",
  opacity: "0.8",
  fontWeight: "400",
  fontFamily: "inherit",
  border: "1.5px solid rgba(255, 255, 255, 0.6)",
  marginLeft: "5px",
  alignItems: "center",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  textAlign: "center",
  cursor: "pointer",
});
const FooterBox = styled("div")({
  color: "#fff",
});

function DefaultFooter({ content }) {
  const { copyright } = content;

  return (
    <FooterBox>
      <MKBox
        component="footer"
        minHeight="55vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgFooter})`,
          display: "grid",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          placeItems: "center",
          px: "0",
        }}
      >
        <Container>
          <Grid container spacing={3} sx={{ pt: "100px" }} alignItems="center">
            <Grid item xs={12} md={3} sx={{ ml: "auto", mb: 3 }}>
              <MKBox>
                <MKTypography color="white" textTransform="uppercase" variant="h2">
                  contact us
                </MKTypography>
                <MKTypography
                  textTransform="uppercase"
                  variant="h4"
                  sx={{ color: "rgba(252, 201, 7, 1)", my: "10px" }}
                >
                  principal
                  <hr />
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 0.6)", my: "5px", fontSize: "16px" }}
                >
                  Sree Narayana Law College
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 0.6)", my: "5px", fontSize: "16px" }}
                >
                  Puthenkavu Poothotta P.O
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 0.6)", my: "5px", fontSize: "16px" }}
                >
                  Ernakulam, Kerala Pin: 682307.
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 1)", pt: "25px", fontSize: "16px" }}
                >
                  0484-2794377, 8589982030
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 1)", pt: "25px", fontSize: "16px" }}
                >
                  snlcpoothotta@gmail.com
                </MKTypography>
                <MKTypography sx={{ color: "rgba(255, 255, 255, 1)", pt: "5px", fontSize: "16px" }}>
                  Fax: 0484 2792377
                </MKTypography>
              </MKBox>
              {/* <MKBox display="flex" alignItems="center" mt={3}>
                {socials.map(({ icon, link }, key) => (
                  <MKTypography
                    key={link}
                    component="a"
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    variant="h5"
                    color="dark"
                    opacity={0.8}
                    mr={key === socials.length - 1 ? 0 : 2.5}
                  >
                    {icon}
                  </MKTypography>
                ))}
              </MKBox> */}
            </Grid>
            <Grid item xs={12} md={3} sx={{ ml: "auto", mb: 3 }}>
              <MKBox>
                <MKTypography
                  textTransform="uppercase"
                  variant="h4"
                  sx={{ color: "rgba(252, 201, 7, 1)" }}
                >
                  manager
                  <hr />
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 0.6)", my: "5px", fontSize: "16px" }}
                >
                  Sree Narayana Law College
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 0.6)", my: "5px", fontSize: "16px" }}
                >
                  Puthenkavu Poothotta P.O
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 0.6)", my: "5px", fontSize: "16px" }}
                >
                  Ernakulam, Kerala Pin: 682307.
                </MKTypography>
                <MKTypography
                  sx={{ color: "rgba(255, 255, 255, 1)", pt: "25px", fontSize: "16px" }}
                >
                  9249544866, 9249544766
                </MKTypography>
              </MKBox>
            </Grid>
            <Grid item xs={12} md={4} sx={{ ml: "auto", mb: 3 }}>
              <MKBox>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={2} sx={{ ml: "auto", mb: 3 }}>
                    <MKTypography
                      sx={{ color: "rgba(252, 201, 7, 0.4)", my: "5px", fontSize: "18px" }}
                    >
                      Home
                    </MKTypography>
                  </Grid>
                  <Grid item xs={12} md={2} sx={{ ml: "auto", mb: 3 }}>
                    <MKTypography
                      sx={{ color: "rgba(252, 201, 7, 0.4)", my: "5px", fontSize: "18px" }}
                    >
                      News
                    </MKTypography>
                  </Grid>
                  <Grid item xs={12} md={3} sx={{ ml: "auto", mb: 3 }}>
                    <MKTypography
                      sx={{ color: "rgba(252, 201, 7, 0.4)", my: "5px", fontSize: "18px" }}
                    >
                      Apply Now
                    </MKTypography>
                  </Grid>
                  <Grid item xs={12} md={2} sx={{ ml: "auto", mb: 3 }}>
                    <MKTypography
                      sx={{ color: "rgba(252, 201, 7, 0.4)", my: "5px", fontSize: "18px" }}
                    >
                      Gallery
                    </MKTypography>
                  </Grid>
                  <Grid item xs={12} md={2} sx={{ ml: "auto", mb: 3 }}>
                    <MKTypography
                      sx={{ color: "rgba(252, 201, 7, 0.4)", my: "5px", fontSize: "18px" }}
                    >
                      Contact
                    </MKTypography>
                  </Grid>
                </Grid>
                <hr />
                <MKTypography
                  sx={{
                    color: "rgba(255, 255, 255,1)",
                    my: "5px",
                    fontSize: "25px",
                    textTransform: "uppercase",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  sree narayana law college
                </MKTypography>
                <MKTypography
                  sx={{
                    color: "rgba(252, 201, 7, 0.6)",
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  Puthenkavu Poothotta P.O Ernakulam, Kerala Pin: 682307.
                </MKTypography>
                <MKTypography>
                  <Grid container spacing={2} alignItems="center" justifyContent="center">
                    <Grid item lg={1}>
                      <SocialIcon>
                        <InstagramIcon />
                      </SocialIcon>
                    </Grid>
                    <Grid item lg={1}>
                      <SocialIcon>
                        <LinkedInIcon />
                      </SocialIcon>
                    </Grid>
                    <Grid item lg={1}>
                      <SocialIcon>
                        <FacebookOutlinedIcon />
                      </SocialIcon>
                    </Grid>
                  </Grid>
                </MKTypography>
              </MKBox>
            </Grid>
            <Grid item xs={12} md={2} sx={{ ml: "auto", mb: 3 }}>
              <img src={logoImage} alt="Logo" width="100" />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "end", my: 2 }}>
              {copyright}
            </Grid>
          </Grid>
        </Container>
      </MKBox>
    </FooterBox>
  );
}

// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
